import React, { ReactNode, Suspense, lazy } from "react";
import OrgIcon from "../assets/icons/CLUB __ DARK.svg";
import AdminIcon from "../assets/icons/CUSTOMERS __ DARK.svg";
//import PricingIcon from "../assets/icons/PRICING __ DARK.svg";
import NotificationIcon from "../assets/icons/NOTIFICATIONS.svg";
import SystemIcon from "../assets/icons/profile-icon.svg";

import { ImgIcon } from "../utils/utils";
import { RoutesConfig } from "../types";

import AcademyIcon from "../assets/icons/AcademyIcon";
import HomeIcon from "../assets/icons/HomeIcon";
import AddServicesMenuIcon from "../assets/icons/AddServicesMenuIcon";
import ImageIcon from "../components/global/ImageIcon";
import BigCoach from "../assets/icons/BigCoachIcon";
import CalendarIcon from "../assets/icons/CalendarIcon";
import CardIcon from "../assets/icons/CardIcon";
import ClubIcon from "../assets/icons/ClubIcon";
import ClubCustomersIcon from "../assets/icons/ClubCustomersIcon";
import EyeClosedIcon from "../assets/icons/EyeClosedIcon";
import LeaguesIcon from "../assets/icons/LeaguesIcon";
import NotificationsIcon from "../assets/icons/NotificationsIcon";
import TournamentIcon from "../assets/icons/TournamentIcon";
import PaymentIcon from "../assets/icons/PaymentIcon";
import PricingIcon from "../assets/icons/PricingIcon";
import ProfileIcon from "../assets/icons/ProfileIcon";
import PublicEventsIcon from "../assets/icons/PublicEventsIcon";
import CourtsIcon from "../assets/icons/CourtsIcon";
import PosIcon from "../assets/icons/PosIcon";
import PaymentMethodIcon from "../assets/icons/PaymentMethodIcon";

import RepotIcon from "../assets/icons/RepotIcon";

import GameWithCoachIcon from "../assets/icons/GameWithCoachIcon";
import PublicCoachingIcon from "../assets/icons/PublicCoachingIcon";
import Clubsicon from "../assets/icons/Clubsicon";
import ClubAdminsIcon from "../assets/icons/ClubAdminsIcon";
import FirstScreen from "../pages/Auth/FirstScreen";
import Loader from "../components/skeletons/Loader";

import WalletUsersPage from "../pages/customers/WalletUsersPage";
import MembershipInfoOne from "../pages/customers/MembershipInfoOne";
import MembershipInfoTwo from "../pages/customers/MembershipInfoTwo";
import CreateSecondStepFormV2 from "../components/league-tournament/CreateSecondStepFormV2";
import RunnerUp from "../pages/leagues/RunnerUp";
import KnockoutBracket from "../pages/leagues/KnockoutBrackets";
import CreateEventSecondStepFormV2 from "../components/events/CreateSecondStepFormV2";
import CustomerMemberships from "../pages/customers/CustomerMemberships";
import CustomerAllVouchersPage from "../pages/customers/CustomerAllVouchersPage";
const HomePage = lazy(() => import("../pages/home/Home"));
const Pricing = lazy(() => import("../pages/pricing/Pricing"));
const PriceList = lazy(() => import("../pages/pricing/PriceList"));
const ClubDetails = lazy(
  () => import("../pages/organization/clubDetails/ClubDetails")
);
const Organization = lazy(() => import("../pages/organization/Organization"));
const Admin = lazy(() => import("../pages/clubs/Admin"));
const Mangement = lazy(() => import("../pages/clubs/Mangement"));
const Coaches = lazy(() => import("../pages/coaches/Coaches"));
const AddOns = lazy(() => import("../pages/add ons/AddOns"));
const CoachDetails = lazy(
  () => import("../pages/coaches/coachDetails/CoachDetails")
);
const CustomersPage = lazy(() => import("../pages/customers/CustomersPage"));
const CustomersInfo = lazy(() => import("../pages/customers/CustomersInfo"));
const NembershipInfo = lazy(
  () => import("../pages/customers/MembershipInfoOne")
);
const Courts = lazy(() => import("../pages/courts/Courts"));
const CourtDetails = lazy(
  () => import("../pages/courts/courtDetails/CourtDetails")
);
const PaymentMethods = lazy(
  () => import("../pages/payment methods/PaymentMethods")
);
const Profile = lazy(() => import("../pages/profile/Profile"));
const Booking = lazy(() => import("../pages/booking/Booking"));
const Pos = lazy(() => import("../pages/pos/Pos"));
const Payments = lazy(() => import("../pages/payments/Payments"));
const Leagues = lazy(() => import("../pages/leagues/Leagues"));
const LeaguesPlayers = lazy(
  () => import("../pages/leagues/leagues players/LeaguesPlayers")
);
const CreateLeagues = lazy(() => import("../pages/leagues/CreateLeagues"));
const LeaguesExcution = lazy(
  () => import("../pages/leagues/leagues players/LeaguesExcutionPage")
);
const LeaguesKnockouts = lazy(
  () => import("../pages/leagues/leagues knockouts/LeaguesKnockouts")
);
const LeaguesRounds = lazy(
  () => import("../pages/leagues/leagues rounds/LeaguesRounds")
);
const Events = lazy(() => import("../pages/events/Events"));
const EventPlayers = lazy(() => import("../pages/events/players/EventPlayers"));
const CreateEvent = lazy(() => import("../pages/events/CreateEvent"));
const ChatPage = lazy(() => import("../pages/chat/ChatPage"));
const EventRounds = lazy(
  () => import("../pages/events/event rounds/EventRounds")
);
const PlayersScore = lazy(
  () => import("../pages/events/players score/PlayersScore")
);
const RedirectTo404 = lazy(() => import("../pages/404/RedirectTo404"));
const MembershipSaleInfo = lazy(
  () => import("../pages/customers/MembershipSaleInfo")
);
const Notification = lazy(() => import("../pages/notification/Notification"));
const Clubs = lazy(() => import("../pages/clubs-section/Clubs"));
const GameWithCoach = lazy(() => import("../pages/coaches/GameWithCoach"));
const PublicCoaching = lazy(() => import("../pages/coaches/PublicCoaching"));
const PrivateCoaching = lazy(() => import("../pages/coaches/PrivateCoaching"));
const Academy = lazy(() => import("../pages/academy/Academy"));
const CreateAcademy = lazy(() => import("../pages/academy/CreateAcademy"));
const AddPlayers = lazy(() => import("../pages/academy/AddPlayers"));
const MembershipSalesUsers = lazy(
  () => import("../pages/customers/MembershipSalesUsers")
);
const PackegeInfo = lazy(() => import("../pages/customers/PackegeInfo"));
const Report = lazy(() => import("../pages/report/Report"));

const Loadable = ({ children }: { children: ReactNode }) => (
  <Suspense
    fallback={
      <div className="w-full h-[calc(100dvh-200px)] flex flex-col justify-center items-center">
        <Loader />
      </div>
    }
  >
    {children}
  </Suspense>
);
export const routes: RoutesConfig = [
  {
    path: "/",
    role: ["all"],
    title: "main",
    isMainPage: false,
    element: (
      <Loadable>
        <FirstScreen />
      </Loadable>
    ),
  },
  {
    path: "/profile",
    role: ["all"],
    tag: "Profile",
    title: "My Profile",
    icon: () => <ImageIcon Icon={ProfileIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Profile />
      </Loadable>
    ),
  },
  {
    path: "/home",
    redirect: "/home",
    role: ["all"],
    title: "Home",
    tag: "Home",
    //icon: (width?: number, height?: number) => ImgIcon(homeIcon, width, height),
    icon: () => <ImageIcon Icon={HomeIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <HomePage />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/organization/:club_id",
    redirect: "/club-settings/organization",
    role: ["all"],
    title: "Organization",
    tag: "Organization",
    icon: () => <ImageIcon Icon={ClubIcon} width={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <ClubDetails />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/organization",
    redirect: "/club-settings/organization",
    role: ["all"],
    title: "Organization",
    tag: "Organization",
    icon: () => <ImageIcon Icon={ClubIcon} width={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Organization />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/clubs",
    redirect: "/club-settings/clubs",
    role: ["all"],
    title: "Clubs",
    tag: "Clubs",
    icon: () => <ImageIcon Icon={Clubsicon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Clubs />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/coaches",
    redirect: "/club-settings/coaches",
    role: ["all"],
    title: "Coaches",
    tag: "Coaches",
    icon: () => <ImageIcon Icon={BigCoach} width={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Coaches />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/courts/:court_id",
    redirect: "/club-settings/courts",
    role: ["all"],
    title: "Courts",
    tag: "Courts",
    icon: () => <ImageIcon Icon={CourtsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CourtDetails />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/courts",
    redirect: "/club-settings/courts",
    role: ["all"],
    title: "Courts",
    tag: "Courts",
    icon: () => <ImageIcon Icon={CourtsIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Courts />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/pricing",
    redirect: "/club-settings/pricing",
    role: ["all"],
    title: "Pricing",
    tag: "Pricing",
    icon: PricingIcon,
    isMainPage: false,
    element: (
      <Loadable>
        <Pricing />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/coaches/:coach_id",
    redirect: "/club-settings/coaches",
    role: ["all"],
    title: "Coaches",
    tag: "Coaches",
    icon: () => <ImageIcon Icon={BigCoach} width={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CoachDetails />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/pos",
    redirect: "/club-settings/pos",
    role: ["all"],
    title: "POS",
    tag: "POS",
    icon: () => <ImageIcon Icon={PosIcon} width={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Pos />
      </Loadable>
    ),
  },
  {
    path: "/general/payments",
    redirect: "/general/payments",
    role: ["all"],
    title: "Payments",
    tag: "Payments",
    icon: () => <ImageIcon Icon={PaymentIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Payments />
      </Loadable>
    ),
  },
  {
    path: "/general/pricing",
    redirect: "/general/pricing",
    role: ["all"],
    title: "pricing",
    tag: "Pricing",
    icon: () => <ImageIcon Icon={PricingIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Pricing />
      </Loadable>
    ),
  },
  {
    path: "/general/payment-methods",
    redirect: "/general/payment-methods",
    role: ["all"],
    title: "Payment methods",
    tag: "Payment Methods",
    icon: () => (
      <ImageIcon
        Icon={PaymentMethodIcon}
        width={42}
        height={42}
        className="w-[42px]"
      />
    ),
    isMainPage: true,
    element: (
      <Loadable>
        <PaymentMethods />
      </Loadable>
    ),
  },
  {
    path: "/general/pricing/list/:id",
    redirect: "/general/pricing?currentPage=1&currentSize=10",
    role: ["all"],
    title: "Pricing",
    tag: "Pricing",
    icon: PricingIcon,
    isMainPage: false,
    element: (
      <Loadable>
        <PriceList />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/admin",
    redirect: "/club-settings/admin",
    role: ["all"],
    title: "Club admins",
    tag: "Club Admins",
    icon: () => <ImageIcon Icon={ClubAdminsIcon} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Admin />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: true,
    element: (
      <Loadable>
        <CustomersPage />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer/voucher/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Vouchers",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=Vouchers",
      },
      {
        title: "users",
        position: "last",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <WalletUsersPage />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer/new",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CustomersInfo type="new" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer/edit/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CustomersInfo type="edit" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer/view/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CustomersInfo type="view" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer/membership/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Customer Memberships",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CustomerMemberships />
      </Loadable>
    ),
   
  },
  {
    path: "/club-settings/membership/membershipSale/:userId",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipSaleInfo />
      </Loadable>
    ),
    subNavs: [{ title: "Membership Sale" }],
  },

  {
    path: "/club-settings/membership/new",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipInfoOne type="new" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/membership/edit/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipInfoOne type="edit" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/membership/duplicate/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipInfoOne type="duplicate" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/membership/view/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipInfoOne type="view" />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/membership/step2/edit/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipInfoTwo type="edit" />
      </Loadable>
    ),
  },

  {
    path: "/club-settings/membership/step2/view/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipInfoTwo type="view" />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/membership/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",

    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <MembershipSalesUsers />
      </Loadable>
    ),
    subNavs: [
      {
        title: "Memberships",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=memberships",
      },
      { title: "Membership Sale" },
    ],
  },
  {
    path: "/club-settings/packages/view/:id",
    redirect: "/club-settings/customer",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    subNavs: [
      {
        title: "Packages",
        link: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=packages",
      },
      {
        title: "Package",
      },
    ],
    isMainPage: false,
    element: (
      <Loadable>
        <PackegeInfo />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/services",
    redirect: "/club-settings/services",
    role: ["all"],

    title: "Roles",
    tag: "Roles",
    icon: () => <ImageIcon Icon={ProfileIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Mangement />
      </Loadable>
    ),
  },
  {
    path: "/club-settings/customer/data/voucher/:id",
    redirect:
      "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
    role: ["all"],
    title: "Club customers",
    tag: "Club Customers",
    icon: () => <ImageIcon Icon={ClubCustomersIcon} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CustomerAllVouchersPage />
      </Loadable>
    ),
  },
  // {
  //   path: "/club-settings/add-ons",
  //   redirect: "/club-settings/add-ons",
  //   role: ["all"],
  //   title: "Add-Ons and Services",
  //   tag: "Extras",
  //   icon: () => (
  //     <ImageIcon
  //       Icon={AddServicesMenuIcon}
  //       width={42}
  //       height={42}
  //       className="w-[42px]"
  //     />
  //   ),
  //   isMainPage: true,
  //   element: (
  //     <Loadable>
  //       <AddOns />
  //     </Loadable>
  //   ),
  // },

  {
    path: "/competitive/leagues",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Leagues />
      </Loadable>
    ),
  },
  {
    path: "/competitive/leagues/edit/step1/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="leagues" eventType="edit" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
    BreadcrumbItems:['Edit']
  },

  {
    path: "/competitive/leagues/view/step1/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="leagues" eventType="view" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
     BreadcrumbItems:['View']
  },
  {
    path: "/competitive/leagues/view/step2/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="leagues" eventType="view" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/competitive/leagues/duplicate/step1/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        {" "}
        <CreateLeagues step={1} type="leagues" eventType="duplicate" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
     BreadcrumbItems:['Duplicate']
  },
  {
    path: "/competitive/leagues/edit/step2/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="leagues" eventType="edit" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/competitive/leagues/duplicate/step2/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="leagues" eventType="duplicate" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/competitive/leagues/leagues-players/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesPlayers />
      </Loadable>
    ),
    BreadcrumbItems: ["Create","Teams"]
  },

  {
    path: "/competitive/leagues/knockouts/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesKnockouts />
      </Loadable>
    ),
  },
  {
    path: "/competitive/leagues/generate/knockouts/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesKnockouts showType="generate" />
      </Loadable>
    ),
  },
  {
    path: "/competitive/leagues/rounds/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesRounds showType="score" />
      </Loadable>
    ),
  },
  {
    path: "/competitive/leagues/generate/rounds/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesRounds showType="generate" />
      </Loadable>
    ),
  },
  {
    path: "/competitive/leagues/leagues-execution/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesExcution />
      </Loadable>
    ),
  },
  {
    path: "/competitive/tournaments/tournaments-execution/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesExcution type="tournaments" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups"]
  },
  {
    path: "/competitive/leagues/new/step1",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="leagues" eventType="new" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
     BreadcrumbItems:['Create']
    //hiddenQuerys:[]
  },
  {
    path: "/competitive/leagues/new/step2",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="leagues" eventType="new" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
    //hiddenQuerys:[]
  },

  {
    path: "/competitive/leagues/edit/schedule/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"leagues"} eventType="edit" stage="rounds" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule"]
  },
    {
    path: "/competitive/leagues/edit/schedule/knockouts/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"leagues"} eventType="edit" stage="knockouts" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Match results","Qualified teams","Knockout bracket","Knockout schedule"]
  },
  {
    path: "/competitive/leagues/view/schedule/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"leagues"} eventType="view" stage="rounds" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule"]
  },
   {
    path: "/competitive/leagues/view/schedule/knockouts/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"leagues"} eventType="view" stage="knockouts" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule"]
  },
{
    
    path: "/competitive/leagues/KnockoutBracket/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <KnockoutBracket type="league"/>
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Match results","Qualified teams","Knockout bracket"]
  },
  {
    path: "/competitive/tournaments/edit/schedule/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"tournaments"} eventType="edit" stage="rounds" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule"]
  },
    {
    path: "/competitive/tournaments/edit/schedule/knockouts/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"tournaments"} eventType="edit" stage="knockouts" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Match results","Qualified teams","Knockout bracket","Knockout schedule"]
  },

  {
    path: "/competitive/tournaments/view/schedule/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"tournaments"} eventType="view" stage="rounds" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule"]
  },
  {
    path: "/competitive/tournaments/view/schedule/knockouts/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateSecondStepFormV2 type={"tournaments"} eventType="view" stage="knockouts" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule"]
  },
  {
    path: "/competitive/tournaments",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Leagues type="tournaments" />
      </Loadable>
    ),
  },

  {
    path: "/competitive/tournaments/tournaments-players/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesPlayers type="tournaments" />
      </Loadable>
    ),
    BreadcrumbItems: ["Create","Teams"]
  },
  {
    path: "/competitive/tournaments/new/step1",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournament",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="tournaments" eventType="new" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
    BreadcrumbItems:['Create']
    //hiddenQuerys:[]
  },
  {
    path: "/competitive/tournaments/new/step2",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournament",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="tournaments" eventType="new" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
    //hiddenQuerys:[]
  },
  {
    path: "/competitive/tournaments/edit/step1/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="tournaments" eventType="edit" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
    BreadcrumbItems:['Edit']
  },
  {
    path: "/competitive/tournaments/view/step1/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="tournaments" eventType="view" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
    BreadcrumbItems:['View']
  },
  {
    path: "/competitive/tournaments/view/step2/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        {" "}
        <CreateLeagues step={2} type="tournaments" eventType="view" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/competitive/tournaments/duplicate/step1/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={1} type="tournaments" eventType="duplicate" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
    BreadcrumbItems:['Duplicate']
  },
  {
    path: "/competitive/tournaments/edit/step2/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="tournaments" eventType="edit" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/competitive/tournaments/duplicate/step2/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateLeagues step={2} type="tournaments" eventType="duplicate" />
      </Loadable>
    ),

    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
  },

  {
    path: "/competitive/tournaments/rounds/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesRounds showType="score" type="tournaments" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Round results"]
  },

  {
    path: "/competitive/tournaments/generate/rounds/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesRounds showType="generate" type="tournaments" />
      </Loadable>
    ),
     BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Rounds generation"]
    
  },
  
  {
    path: "/competitive/tournaments/knockouts/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesKnockouts showType="score" type="tournaments" />
      </Loadable>
    ),
        BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Knockouts results"]
  },

  {
    path: "/competitive/tournaments/generate/knockouts/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <LeaguesKnockouts showType="generate" type="tournaments" />
      </Loadable>
    ),
     BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Knockouts generation"]
  },
  {
    
    path: "/competitive/tournaments/runnerUp/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <RunnerUp pageType="tournament"/>
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Match results","Qualified teams"]
  },
   {
    
    path: "/competitive/leagues/runnerUp/:id",
    redirect: "/competitive/leagues",
    role: ["all"],
    title: "Leagues",
    tag: "Leagues",
    icon: () => <ImageIcon Icon={LeaguesIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <RunnerUp pageType="league"/>
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Match results","Qualified teams"]
  },
  {
    
    path: "/competitive/tournaments/KnockoutBracket/:id",
    redirect: "/competitive/tournaments",
    role: ["all"],
    title: "Tournaments",
    tag: "Tournaments",
    icon: () => <ImageIcon Icon={TournamentIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <KnockoutBracket type="tournament"/>
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","Groups","Round robin schedule","Match results","Qualified teams","Knockout bracket"]
  },
  
  //---------------EVENTS----------------------

  {
    path: "/friendly/public",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Events type={"public"} />
      </Loadable>
    ),
  },

  {
    path: "/friendly/public/edit/schedule/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEventSecondStepFormV2 type={"public"} eventType="edit" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","schedule"]
  },

  {
    path: "/friendly/public/view/schedule/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEventSecondStepFormV2 type={"public"} eventType="view" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","schedule"]
  },

  {
    path: "/friendly/private/edit/schedule/:id",
    redirect: "/friendly/private?currentPage=1&currentSize=10",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEventSecondStepFormV2 type={"private"} eventType="edit" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","schedule"]
  },

  {
    path: "/friendly/private/view/schedule/:id",
    redirect: "/friendly/private?currentPage=1&currentSize=10",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEventSecondStepFormV2 type={"private"} eventType="view" />
      </Loadable>
    ),
    BreadcrumbItems:["Create","Teams","schedule"]
  },

  {
    path: "/friendly/public/event-players/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <EventPlayers type={"public"} />
      </Loadable>
    ),
    BreadcrumbItems:['create','Teams']
  },

  {
    path: "/friendly/public/rounds/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <EventRounds showType="score" type="public" />
      </Loadable>
    ),
  },
  {
    path: "/friendly/public/players-score/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <PlayersScore />
      </Loadable>
    ),
  },

  {
    path: "/friendly/private",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Events type={"private"} />
      </Loadable>
    ),
  },

  {
    path: "/friendly/private/event-players/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <EventPlayers type={"private"} />
      </Loadable>
    ),
        BreadcrumbItems:['create','Teams']
  },

  {
    path: "/friendly/private/rounds/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <EventRounds showType="score" type="private" />
      </Loadable>
    ),
  },
  {
    path: "/friendly/private/players-score/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <PlayersScore />
      </Loadable>
    ),
  },

  {
    path: "/booking",
    redirect: "/booking",
    role: ["all"],
    title: "Booking",
    tag: "Booking",
    icon: (w,h) => (
      <ImageIcon
        Icon={CalendarIcon}
        width={w||42}
        height={h||42}
        className={w?`w-[${w}px]`:''}
      />
    ),
    isMainPage: true,
    element: (
      <Loadable>
        <Booking />
      </Loadable>
    ),
  },
  {
    path: "/booking/:id",
    redirect: "/booking",
    role: ["all"],
    title: "Booking",
    tag: "Booking",
    icon: () => (
      <ImageIcon
        Icon={CalendarIcon}
        width={42}
        height={42}
        className="w-[42px]"
      />
    ),
    isMainPage: false,
    element: (
      <Loadable>
        <Booking />
      </Loadable>
    ),
  },
  {
    path: "/friendly/public/new/step1",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="public" eventType="new" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
    //hiddenQuerys:[]
  },
  {
    path: "/friendly/public/new/step2",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="public" eventType="new" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 2 of 2",
        //path:""
        //icon
      },
    ],
    //hiddenQuerys:[]
  },
  {
    path: "/friendly/public/edit/step1/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="public" eventType="edit" />
      </Loadable>
    ),
    subNavs: [
      {
        title: "step 1 of 2",
        //path:""
        //icon
      },
    ],
  },

  {
    path: "/friendly/public/duplicate/step1/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="public" eventType="duplicate" />
      </Loadable>
    ),
    subNavs: [{ title: "step 1 of 2" }],
  },
  {
    path: "/friendly/public/edit/step2/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="public" eventType="edit" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/friendly/public/duplicate/step2/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="public" eventType="duplicate" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/friendly/public/view/step1/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="public" eventType="view" />
      </Loadable>
    ),
    subNavs: [{ title: "step 1 of 2" }],
  },
  {
    path: "/friendly/public/view/step2/:id",
    redirect: "/friendly/public",
    role: ["all"],
    title: "Public",
    tag: "Events",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="public" eventType="view" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/friendly/private/view/step1/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="private" eventType="view" />
      </Loadable>
    ),
    subNavs: [{ title: "step 1 of 2" }],
  },
  {
    path: "/friendly/private/view/step2/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="private" eventType="view" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/friendly/private/new/step1",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="private" eventType="new" />
      </Loadable>
    ),
    subNavs: [{ title: "step 1 of 2" }],
  },
  {
    path: "/friendly/private/new/step2",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="private" eventType="new" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/friendly/private/edit/step1/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="private" eventType="edit" />
      </Loadable>
    ),
    subNavs: [{ title: "step 1 of 2" }],
  },
  {
    path: "/friendly/private/duplicate/step1/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={1} type="private" eventType="duplicate" />
      </Loadable>
    ),
    subNavs: [{ title: "step 1 of 2" }],
  },
  {
    path: "/friendly/private/edit/step2/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="private" eventType="edit" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/friendly/private/duplicate/step2/:id",
    redirect: "/friendly/private",
    role: ["all"],
    title: "Private",
    tag: "Events",
    icon: () => <ImageIcon Icon={EyeClosedIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <CreateEvent step={2} type="private" eventType="duplicate" />
      </Loadable>
    ),
    subNavs: [{ title: "step 2 of 2" }],
  },
  {
    path: "/chat",
    redirect: "/chat",
    role: ["all"],
    title: "Message",
    tag: "Chat",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <ChatPage />
      </Loadable>
    ),
  },
  {
    path: "/chat/:roomId",
    redirect: "/chat",
    role: ["all"],
    title: "Message",
    tag: "Chat",
    icon: () => <ImageIcon Icon={PublicEventsIcon} width={42} height={42} />,
    isMainPage: false,
    element: (
      <Loadable>
        <ChatPage />
      </Loadable>
    ),
  },
  {
    path: "/notification",
    redirect: "/notification",
    role: ["all"],
    title: "Notification",
    tag: "Notifications",
    icon: () => <ImageIcon Icon={NotificationsIcon} width={42} height={42} />,
    isMainPage: true,
    element: (
      <Loadable>
        <Notification />
      </Loadable>
    ),
  },
  //=================Coaches==========================//

  {
    path: "/coaches/game",
    redirect: "/coaches/game",
    role: ["all"],
    title: "Game with the coach",
    tag: "Game With Coach",
    element: (
      <Loadable>
        <GameWithCoach />
      </Loadable>
    ),
    icon: () => <ImageIcon Icon={GameWithCoachIcon} width={42} />,
    isMainPage: true,
  },
  {
    path: "/coaches/private/game",
    redirect: "/coaches/private/game",
    role: ["all"],
    title: "Private coaching",
    tag: "Private Coaching",
    element: (
      <Loadable>
        <PrivateCoaching />
      </Loadable>
    ),
    icon: () => <ImageIcon Icon={BigCoach} width={42} />,
    isMainPage: true,
  },
  {
    path: "/coaches/public/game",
    redirect: "/coaches/public/game",
    role: ["all"],
    title: "Public coaching",
    tag: "Public Coaching",
    element: (
      <Loadable>
        <PublicCoaching />
      </Loadable>
    ),
    icon: () => <ImageIcon Icon={PublicCoachingIcon} width={42} />,
    isMainPage: true,
  },

  {
    path: "/coaching/Academy/addPlayers/:id",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <AddPlayers type="edit" />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: () => <ImageIcon Icon={AcademyIcon} width={42} />,
    isMainPage: false,
  },
  {
    path: "/coaching/Academy/addPlayers",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <AddPlayers />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: AcademyIcon,
    isMainPage: false,
    subNavs: [
      {
        title: "Add players",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/coaching/Academy",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <Academy />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: AcademyIcon,
    isMainPage: true,
  },
  {
    path: "/coaching/Academy/new",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <CreateAcademy />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: AcademyIcon,
    isMainPage: false,
    hiddenQuery: [],
    subNavs: [
      {
        title: "Add new Academy",
        //path:""
        //icon
      },
    ],
  },
  {
    path: "/coaching/Academy/edit/:id",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <CreateAcademy type="edit" />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: AcademyIcon,
    isMainPage: false,
  },

  {
    path: "/coaching/Academy/view/:id",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <CreateAcademy type="view" />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: AcademyIcon,
    isMainPage: false,
  },
  {
    path: "/coaching/Academy/duplicate/:id",
    redirect: "/coaching/Academy",
    role: ["all"],
    title: "Academy",
    tag: "Academy",
    element: (
      <Loadable>
        <CreateAcademy type="duplicate" />
      </Loadable>
    ),
    //icon: (width?: number, height?: number) => ImgIcon(AcademyIcon, width, height),
    icon: AcademyIcon,
    isMainPage: false,
  },
  {
    path: "/report",
    redirect: "/report",
    role: ["all"],
    title: "Reports",
    tag: "Report",
    isMainPage: true,
    icon: RepotIcon,
    element: (
      <Loadable>
        <Report pageType="report" />
      </Loadable>
    ),
  },
  {
    path: "/dashboard",
    redirect: "/dashboard",
    role: ["all"],
    title: "Reports",
    tag: "Report",
    isMainPage: false,
    icon: RepotIcon,
    element: (
      <Loadable>
        <Report pageType="dashboard" />
      </Loadable>
    ),
  },
  {
    path: "*",
    role: ["all"],
    title: "404",
    isMainPage: false,
    element: <RedirectTo404 />,
  },
];
export const routesSchema = (role = "all") => {
  if (role === "super_admin") return routes;
  const safeRoutes = routes.filter(
    (route) => route.role.includes(role) || route.role.includes("all")
  );
  return safeRoutes;
};
